import {createAction} from 'web-app/util/redux/typed-action-helpers';

import type {useFetchPricingGroupsQuery} from '../../use-fetch-pricing-groups-query';

const domain = 'PRICING_GROUPS';

export const {action: populateRedux} = createAction(
    `${domain}/POPULATE_REDUX`,
    (data?: ReturnType<typeof useFetchPricingGroupsQuery>['data']) => ({
        data,
    }),
);
